<section>

  <div class="title">
    <strong> {{ 'notifications.title' | translate }} </strong>
    <span (click)="markAllRead()" > {{ 'notifications.mark-all-read' | translate }} </span>
  </div>


  <div class="tabs">
    <mat-tab-group (selectedIndexChange)="getNotification($event)">
      <mat-tab [label]=" 'modal-notifications.all' | translate ">
        <div #notificationContainerAll class="notification-container">

          <div
            infiniteScroll
            [infiniteScrollDistance]="1"
            [infiniteScrollThrottle]="200"
            [infiniteScrollContainer]="notificationContainerAll"
            (scrolled)="onScrollDown()"
            [fromRoot]="true"
            *ngIf="!loading; else showLoading">
            <app-notification-item [isCompactMode]="true" [notification]="notification"
              *ngFor="let notification of notifications" (clickNotification)="onClickNotification($event)">
            </app-notification-item>
          </div>
        </div>
      </mat-tab>
      <mat-tab [label]=" 'modal-notifications.not-read' | translate ">
        <div #notificationContainerNotRead class="notification-container2">
        <div
        infiniteScroll
        [infiniteScrollDistance]="1"
        [infiniteScrollThrottle]="200"
        [infiniteScrollContainer]="notificationContainerNotRead"
        (scrolled)="onScrollDown()"
        [fromRoot]="true"
        *ngIf="!loading; else showLoading">
          <app-notification-item [isCompactMode]="true" [notification]="notification" *ngFor="let notification of notificationsNotRead"
          (clickNotification)="onClickNotification($event)"
          > </app-notification-item>
        </div>
        </div>
      </mat-tab>
    </mat-tab-group>

    <ng-template #showLoading>
      <div class="mt-5" style=" width: 100%;">
      <app-loading> </app-loading>
      </div>
  </ng-template>
  </div>



  <div class="d-flex justify-content-end">

    <button mat-button class="btn btn-secondary" (click)="goToNotifications()" >
      {{ 'notifications.go-notifications' | translate }}
    </button>

  </div>

</section>
